module.exports = __webpack_public_path__ + "img/link.a1f73923.svg";